import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isAuth: "",
};

const isAuthSlice = createSlice({
  name: "isAuth",
  initialState,
  reducers: {
    login: (state, action) => {
      state.isAuth = action.payload.token;
    },
    logout: (state) => {
      return initialState;
    },
  },
});

export const { login, logout } = isAuthSlice.actions;
export default isAuthSlice.reducer;
